import { useState, useMemo } from "react";

const TOTAL = { Munro: 282, Corbett: 222, Graham: 224 };

const ALL_MOUNTAINS = [
  { id:1,  name:"Ben Nevis",            height:1345, region:"Lochaber",     list:"Munro",   done:true,  date:"2023-07-15", notes:"Perfect visibility all the way to Ireland" },
  { id:2,  name:"Ben Macdui",           height:1309, region:"Cairngorms",   list:"Munro",   done:true,  date:"2023-08-22", notes:"Cloud on top, navigation by compass" },
  { id:3,  name:"Braeriach",            height:1296, region:"Cairngorms",   list:"Munro",   done:false, date:null,         notes:"" },
  { id:4,  name:"Cairn Toul",           height:1291, region:"Cairngorms",   list:"Munro",   done:false, date:null,         notes:"" },
  { id:5,  name:"Sgor an Lochain Uaine",height:1258, region:"Cairngorms",   list:"Munro",   done:false, date:null,         notes:"" },
  { id:6,  name:"Cairn Gorm",           height:1245, region:"Cairngorms",   list:"Munro",   done:true,  date:"2023-08-23", notes:"Via Ptarmigan chairlift then summit" },
  { id:7,  name:"Buachaille Etive Mor", height:1022, region:"Glencoe",      list:"Munro",   done:true,  date:"2023-09-01", notes:"Classic Curved Ridge scramble" },
  { id:8,  name:"Aonach Eagach",        height:967,  region:"Glencoe",      list:"Munro",   done:false, date:null,         notes:"" },
  { id:9,  name:"Ben Lomond",           height:974,  region:"Loch Lomond",  list:"Munro",   done:true,  date:"2021-06-12", notes:"Very first Munro — emotional!" },
  { id:10, name:"Ben Vorlich",          height:985,  region:"Stirling",     list:"Corbett", done:true,  date:"2022-03-20", notes:"Snow on summit, crampons needed" },
  { id:11, name:"Stuc a' Chroin",       height:975,  region:"Stirling",     list:"Corbett", done:false, date:null,         notes:"" },
  { id:12, name:"Ben Hope",             height:927,  region:"Sutherland",   list:"Corbett", done:true,  date:"2024-07-04", notes:"Most northerly Corbett, great views" },
  { id:13, name:"Suilven",              height:731,  region:"Sutherland",   list:"Corbett", done:true,  date:"2024-07-05", notes:"Iconic sugarloaf shape, long approach" },
  { id:14, name:"Foinaven",             height:911,  region:"Sutherland",   list:"Corbett", done:false, date:null,         notes:"" },
  { id:15, name:"Quinag",               height:809,  region:"Sutherland",   list:"Corbett", done:false, date:null,         notes:"" },
  { id:16, name:"Driesh",               height:947,  region:"Angus Glens",  list:"Graham",  done:true,  date:"2024-05-18", notes:"Combined with Mayar" },
  { id:17, name:"Mount Keen",           height:939,  region:"Cairngorms",   list:"Graham",  done:true,  date:"2024-05-19", notes:"Via Glen Tanar, lovely walk" },
  { id:18, name:"The Storr",            height:719,  region:"Skye",         list:"Graham",  done:true,  date:"2023-04-30", notes:"Old Man of Storr visible throughout" },
  { id:19, name:"Ben Loyal",            height:764,  region:"Sutherland",   list:"Graham",  done:true,  date:"2024-07-06", notes:"Queen of Scottish mountains" },
  { id:20, name:"Bla Bheinn",           height:928,  region:"Skye",         list:"Graham",  done:false, date:null,         notes:"" },
  { id:21, name:"Morven",               height:871,  region:"Grampian",     list:"Graham",  done:false, date:null,         notes:"" },
  { id:22, name:"Tap o' Noth",          height:563,  region:"Grampian",     list:"Graham",  done:false, date:null,         notes:"" },
];

const DONE_COUNT = { Munro: 47, Corbett: 12, Graham: 8 };

const LIST_CFG = {
  Munro:   { bg:"#1E4D8C", ring:"#3b82f6", light:"#eff6ff", pill:"#1d4ed8", label:"914m+",    emoji:"⛰️" },
  Corbett: { bg:"#7C2D12", ring:"#f97316", light:"#fff7ed", pill:"#c2410c", label:"762–914m", emoji:"🏔️" },
  Graham:  { bg:"#14532D", ring:"#22c55e", light:"#f0fdf4", pill:"#15803d", label:"610–762m", emoji:"🌄" },
};

function ProgressRing({ pct, color, size = 80 }) {
  const r = size / 2 - 8;
  const circ = 2 * Math.PI * r;
  const dash = (pct / 100) * circ;
  return (
    <svg width={size} height={size}>
      <circle cx={size/2} cy={size/2} r={r} fill="none" stroke="#e2e8f0" strokeWidth="7" />
      <circle cx={size/2} cy={size/2} r={r} fill="none" stroke={color} strokeWidth="7"
        strokeDasharray={`${dash} ${circ}`} strokeLinecap="round"
        transform={`rotate(-90 ${size/2} ${size/2})`} />
    </svg>
  );
}

function Dashboard({ mountains, setView }) {
  const stats = ["Munro","Corbett","Graham"].map(list => {
    const sample = mountains.filter(m => m.list === list);
    const total = TOTAL[list];
    const done = DONE_COUNT[list];
    return { list, total, done, pct: Math.round((done/total)*100), cfg: LIST_CFG[list] };
  });

  const recent = mountains.filter(m => m.done && m.date).sort((a,b) => b.date.localeCompare(a.date)).slice(0,3);

  return (
    <div style={{display:"flex",flexDirection:"column",gap:"20px"}}>
      {/* Header */}
      <div style={{background:"linear-gradient(135deg,#1C2B1E,#2D4A32)",borderRadius:"12px",padding:"20px 24px",color:"white"}}>
        <div style={{fontSize:"11px",letterSpacing:"3px",color:"#C8962C",fontWeight:700,marginBottom:"6px"}}>POWER APPS CANVAS APP</div>
        <div style={{fontSize:"22px",fontWeight:700,fontFamily:"Georgia,serif"}}>Munroist</div>
        <div style={{fontSize:"13px",color:"#8FA89B",marginTop:"4px"}}>Munros · Corbetts · Grahams — Dataverse powered</div>
      </div>

      {/* 3 list cards */}
      <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:"14px"}}>
        {stats.map(({list,total,done,pct,cfg}) => (
          <div key={list} style={{background:"white",borderRadius:"12px",padding:"18px",boxShadow:"0 2px 8px rgba(0,0,0,0.08)",borderTop:`4px solid ${cfg.bg}`}}>
            <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:"12px"}}>
              <div>
                <div style={{fontSize:"15px",fontWeight:700,color:cfg.bg}}>{list}s</div>
                <div style={{fontSize:"11px",color:"#94a3b8"}}>{cfg.label}</div>
              </div>
              <div style={{position:"relative"}}>
                <ProgressRing pct={pct} color={cfg.ring} size={64} />
                <div style={{position:"absolute",inset:0,display:"flex",alignItems:"center",justifyContent:"center",fontSize:"13px",fontWeight:700,color:cfg.bg}}>{pct}%</div>
              </div>
            </div>
            <div style={{fontSize:"24px",fontWeight:800,color:"#1e293b"}}>{done}<span style={{fontSize:"14px",fontWeight:500,color:"#94a3b8"}}>/{total}</span></div>
            <div style={{height:"4px",background:"#f1f5f9",borderRadius:"2px",marginTop:"8px"}}>
              <div style={{height:"100%",width:`${pct}%`,background:cfg.ring,borderRadius:"2px",transition:"width 0.6s"}} />
            </div>
          </div>
        ))}
      </div>

      {/* Recent ascents */}
      <div style={{background:"white",borderRadius:"12px",padding:"18px",boxShadow:"0 2px 8px rgba(0,0,0,0.08)"}}>
        <div style={{fontSize:"12px",letterSpacing:"2px",color:"#64748b",fontWeight:700,marginBottom:"14px"}}>RECENT ASCENTS</div>
        {recent.map(m => (
          <div key={m.id} style={{display:"flex",alignItems:"center",gap:"12px",padding:"10px 0",borderBottom:"1px solid #f1f5f9"}}>
            <div style={{width:"8px",height:"8px",borderRadius:"50%",background:LIST_CFG[m.list].ring,flexShrink:0}} />
            <div style={{flex:1}}>
              <div style={{fontWeight:600,fontSize:"14px",color:"#1e293b"}}>{m.name}</div>
              <div style={{fontSize:"12px",color:"#94a3b8"}}>{m.region} · {m.height}m</div>
            </div>
            <div style={{textAlign:"right"}}>
              <div style={{fontSize:"12px",fontWeight:600,color:LIST_CFG[m.list].bg,background:LIST_CFG[m.list].light,padding:"2px 8px",borderRadius:"10px"}}>{m.list}</div>
              <div style={{fontSize:"11px",color:"#94a3b8",marginTop:"2px"}}>{m.date}</div>
            </div>
          </div>
        ))}
      </div>

      {/* CTA */}
      <button onClick={() => setView("Log Ascent")} style={{background:"#1C2B1E",color:"#C8962C",border:"none",borderRadius:"10px",padding:"14px",fontSize:"14px",fontWeight:700,cursor:"pointer",letterSpacing:"1px"}}>
        + LOG A NEW ASCENT
      </button>
    </div>
  );
}

function HillList({ mountains, setMountains }) {
  const [listFilter, setListFilter] = useState("All");
  const [regionFilter, setRegionFilter] = useState("");
  const [showDone, setShowDone] = useState(true);
  const [sortBy, setSortBy] = useState("height");

  const regions = [...new Set(mountains.map(m => m.region))].sort();

  // This mirrors the Power FX: Filter(Hills, classification = ddlListType.Selected.Value && StartsWith(region, txtSearch.Text) && (chkShowCompleted.Value || IsBlank(LookUp(Ascents, hill_id = ThisItem.hill_id).ascent_id)))
  const filtered = useMemo(() => {
    return mountains
      .filter(m => listFilter === "All" || m.list === listFilter)
      .filter(m => !regionFilter || m.region === regionFilter)
      .filter(m => showDone || !m.done)
      .sort((a,b) => sortBy === "height" ? b.height - a.height : a.name.localeCompare(b.name));
  }, [mountains, listFilter, regionFilter, showDone, sortBy]);

  const toggle = (id) => {
    setMountains(prev => prev.map(m => m.id === id ? {...m, done: !m.done, date: !m.done ? new Date().toISOString().slice(0,10) : null} : m));
  };

  return (
    <div style={{display:"flex",flexDirection:"column",gap:"14px"}}>
      {/* Filters bar — mirrors Canvas App filter controls */}
      <div style={{background:"white",borderRadius:"12px",padding:"14px 16px",boxShadow:"0 2px 8px rgba(0,0,0,0.06)"}}>
        <div style={{fontSize:"11px",letterSpacing:"2px",color:"#64748b",fontWeight:700,marginBottom:"10px"}}>FILTER  ·  mirrors Power FX Filter() delegation</div>
        <div style={{display:"flex",gap:"10px",flexWrap:"wrap",alignItems:"center"}}>
          {["All","Munro","Corbett","Graham"].map(l => (
            <button key={l} onClick={() => setListFilter(l)} style={{
              padding:"6px 14px",borderRadius:"20px",border:"none",cursor:"pointer",fontSize:"13px",fontWeight:600,
              background: listFilter === l ? (l === "All" ? "#1C2B1E" : LIST_CFG[l]?.bg) : "#f1f5f9",
              color: listFilter === l ? "white" : "#64748b",
              transition:"all 0.15s"
            }}>{l}</button>
          ))}
          <select value={regionFilter} onChange={e => setRegionFilter(e.target.value)} style={{padding:"6px 10px",borderRadius:"8px",border:"1px solid #e2e8f0",fontSize:"13px",color:"#374151",cursor:"pointer"}}>
            <option value="">All Regions</option>
            {regions.map(r => <option key={r} value={r}>{r}</option>)}
          </select>
          <label style={{display:"flex",alignItems:"center",gap:"6px",fontSize:"13px",color:"#64748b",cursor:"pointer"}}>
            <input type="checkbox" checked={showDone} onChange={e => setShowDone(e.target.checked)} style={{cursor:"pointer"}} />
            Show completed
          </label>
          <select value={sortBy} onChange={e => setSortBy(e.target.value)} style={{padding:"6px 10px",borderRadius:"8px",border:"1px solid #e2e8f0",fontSize:"13px",color:"#374151",cursor:"pointer",marginLeft:"auto"}}>
            <option value="height">Sort: Height</option>
            <option value="name">Sort: Name</option>
          </select>
        </div>
      </div>

      {/* Results */}
      <div style={{fontSize:"12px",color:"#94a3b8",paddingLeft:"4px"}}>{filtered.length} hills shown</div>
      <div style={{display:"flex",flexDirection:"column",gap:"8px",maxHeight:"420px",overflowY:"auto"}}>
        {filtered.map(m => {
          const cfg = LIST_CFG[m.list];
          return (
            <div key={m.id} style={{background:"white",borderRadius:"10px",padding:"12px 16px",boxShadow:"0 1px 4px rgba(0,0,0,0.06)",display:"flex",alignItems:"center",gap:"14px",opacity:m.done ? 1 : 0.85}}>
              <button onClick={() => toggle(m.id)} style={{
                width:"28px",height:"28px",borderRadius:"50%",border:`2px solid ${m.done ? cfg.ring : "#d1d5db"}`,
                background: m.done ? cfg.ring : "white",cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,transition:"all 0.2s"
              }}>
                {m.done && <span style={{color:"white",fontSize:"14px",fontWeight:700}}>✓</span>}
              </button>
              <div style={{flex:1,minWidth:0}}>
                <div style={{fontWeight:700,fontSize:"14px",color: m.done ? "#64748b" : "#1e293b",textDecoration:m.done?"line-through":"none"}}>{m.name}</div>
                <div style={{fontSize:"12px",color:"#94a3b8"}}>{m.region} · {m.height}m · {m.list}</div>
              </div>
              {m.done && m.date && <div style={{fontSize:"11px",color:"#94a3b8",whiteSpace:"nowrap"}}>{m.date}</div>}
              <div style={{fontSize:"11px",background:cfg.light,color:cfg.pill,padding:"3px 8px",borderRadius:"8px",fontWeight:600,flexShrink:0}}>{m.list}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

function LogAscent({ mountains, setMountains, setView }) {
  const unclimbed = mountains.filter(m => !m.done);
  const [sel, setSel] = useState("");
  const [date, setDate] = useState(new Date().toISOString().slice(0,10));
  const [notes, setNotes] = useState("");
  const [conditions, setConditions] = useState("Clear");
  const [submitted, setSubmitted] = useState(false);

  const submit = () => {
    if (!sel) return;
    setMountains(prev => prev.map(m => m.id === parseInt(sel) ? {...m, done:true, date, notes} : m));
    setSubmitted(true);
    // Simulate Power Automate milestone flow triggering
    setTimeout(() => { setSubmitted(false); setView("Dashboard"); }, 2000);
  };

  const chosen = mountains.find(m => m.id === parseInt(sel));

  if (submitted) return (
    <div style={{background:"white",borderRadius:"16px",padding:"40px",textAlign:"center",boxShadow:"0 4px 20px rgba(0,0,0,0.1)"}}>
      <div style={{fontSize:"48px",marginBottom:"16px"}}>🎉</div>
      <div style={{fontSize:"20px",fontWeight:700,color:"#1C2B1E",marginBottom:"8px"}}>Ascent logged!</div>
      <div style={{fontSize:"14px",color:"#64748b",marginBottom:"16px"}}>Power Automate flow triggered — checking milestone...</div>
      <div style={{background:"#f0fdf4",borderRadius:"8px",padding:"12px",fontSize:"13px",color:"#15803d",fontWeight:600}}>
        ✓ Dataverse record created · ✓ Progress updated · ✓ Milestone check running
      </div>
    </div>
  );

  return (
    <div style={{background:"white",borderRadius:"12px",padding:"20px 24px",boxShadow:"0 2px 8px rgba(0,0,0,0.08)"}}>
      <div style={{fontSize:"11px",letterSpacing:"2px",color:"#64748b",fontWeight:700,marginBottom:"16px"}}>LOG ASCENT  ·  Writes to Dataverse · triggers Power Automate</div>

      <div style={{display:"flex",flexDirection:"column",gap:"14px"}}>
        <div>
          <label style={{fontSize:"12px",fontWeight:700,color:"#374151",display:"block",marginBottom:"6px"}}>Hill</label>
          <select value={sel} onChange={e => setSel(e.target.value)} style={{width:"100%",padding:"10px",borderRadius:"8px",border:"1px solid #e2e8f0",fontSize:"14px",color:"#374151"}}>
            <option value="">— select a hill —</option>
            {["Munro","Corbett","Graham"].map(list => (
              <optgroup key={list} label={list + "s"}>
                {unclimbed.filter(m => m.list === list).map(m => (
                  <option key={m.id} value={m.id}>{m.name} ({m.height}m) · {m.region}</option>
                ))}
              </optgroup>
            ))}
          </select>
        </div>

        {chosen && (
          <div style={{background:LIST_CFG[chosen.list].light,borderRadius:"8px",padding:"12px",borderLeft:`4px solid ${LIST_CFG[chosen.list].ring}`}}>
            <div style={{fontWeight:700,color:LIST_CFG[chosen.list].bg}}>{chosen.name}</div>
            <div style={{fontSize:"12px",color:"#64748b"}}>{chosen.height}m · {chosen.region} · {chosen.list}</div>
          </div>
        )}

        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"12px"}}>
          <div>
            <label style={{fontSize:"12px",fontWeight:700,color:"#374151",display:"block",marginBottom:"6px"}}>Date climbed</label>
            <input type="date" value={date} onChange={e => setDate(e.target.value)} style={{width:"100%",padding:"9px",borderRadius:"8px",border:"1px solid #e2e8f0",fontSize:"14px",boxSizing:"border-box"}} />
          </div>
          <div>
            <label style={{fontSize:"12px",fontWeight:700,color:"#374151",display:"block",marginBottom:"6px"}}>Conditions</label>
            <select value={conditions} onChange={e => setConditions(e.target.value)} style={{width:"100%",padding:"10px",borderRadius:"8px",border:"1px solid #e2e8f0",fontSize:"14px"}}>
              {["Clear","Cloudy","Rain","Snow","Mist","Wind"].map(c => <option key={c}>{c}</option>)}
            </select>
          </div>
        </div>

        <div>
          <label style={{fontSize:"12px",fontWeight:700,color:"#374151",display:"block",marginBottom:"6px"}}>Notes</label>
          <textarea value={notes} onChange={e => setNotes(e.target.value)} placeholder="Route taken, highlights, conditions..." rows={3}
            style={{width:"100%",padding:"10px",borderRadius:"8px",border:"1px solid #e2e8f0",fontSize:"14px",resize:"vertical",boxSizing:"border-box"}} />
        </div>

        <button onClick={submit} disabled={!sel} style={{
          background: sel ? "#1C2B1E" : "#e2e8f0", color: sel ? "#C8962C" : "#94a3b8",
          border:"none",borderRadius:"10px",padding:"14px",fontSize:"14px",fontWeight:700,cursor:sel?"pointer":"default",letterSpacing:"1px"
        }}>
          SUBMIT ASCENT →
        </button>
      </div>
    </div>
  );
}

const CANNED = [
  { q:"Which Munros have I not done in Cairngorms?", fn:(m) => m.filter(h => h.list==="Munro" && h.region==="Cairngorms" && !h.done) },
  { q:"How many Corbetts are left in Sutherland?",   fn:(m) => m.filter(h => h.list==="Corbett" && h.region==="Sutherland" && !h.done) },
  { q:"Show all completed Grahams",                  fn:(m) => m.filter(h => h.list==="Graham" && h.done) },
  { q:"What's my highest unclimbed hill?",           fn:(m) => [m.filter(h => !h.done).sort((a,b) => b.height-a.height)[0]].filter(Boolean) },
];

function CopilotPanel({ mountains }) {
  const [messages, setMessages] = useState([
    { role:"bot", text:"Hi! I'm your hills assistant powered by Copilot Studio. Ask me about your progress, remaining hills by region, or recommendations. Try one of the suggestions below." }
  ]);
  const [input, setInput] = useState("");
  const [typing, setTyping] = useState(false);

  const sendCanned = (q, fn) => {
    setMessages(prev => [...prev, { role:"user", text:q }]);
    setTyping(true);
    setTimeout(() => {
      const results = fn(mountains);
      let reply;
      if (results.length === 0) {
        reply = "Great news — you've completed all hills matching that query! 🎉";
      } else if (results.length === 1) {
        const h = results[0];
        reply = `${h.name} (${h.height}m, ${h.region}) — your highest unclimbed hill. A great next target!`;
      } else {
        reply = `Found ${results.length} hills:\n` + results.map(h => `• ${h.name} — ${h.height}m (${h.region})`).join("\n");
      }
      setMessages(prev => [...prev, { role:"bot", text:reply }]);
      setTyping(false);
    }, 900);
  };

  const sendFree = () => {
    if (!input.trim()) return;
    const q = input;
    setInput("");
    setMessages(prev => [...prev, { role:"user", text:q }]);
    setTyping(true);
    setTimeout(() => {
      const total = mountains.filter(m=>m.done).length;
      setMessages(prev => [...prev, { role:"bot", text:`You've logged ${total} ascents total across all three lists. Your next closest milestone: ${282-DONE_COUNT.Munro} Munros to completion. Would you like suggestions for your next outing?` }]);
      setTyping(false);
    }, 1000);
  };

  return (
    <div style={{display:"flex",flexDirection:"column",gap:"12px"}}>
      <div style={{background:"linear-gradient(135deg,#1C2B1E,#2D4A32)",borderRadius:"12px",padding:"14px 18px",color:"white"}}>
        <div style={{fontSize:"11px",letterSpacing:"2px",color:"#C8962C",fontWeight:700}}>COPILOT STUDIO</div>
        <div style={{fontSize:"13px",color:"#8FA89B",marginTop:"2px"}}>Natural language queries via Dataverse connector</div>
      </div>

      {/* Chat window */}
      <div style={{background:"#f8fafc",borderRadius:"12px",padding:"16px",height:"320px",overflowY:"auto",display:"flex",flexDirection:"column",gap:"10px"}}>
        {messages.map((msg,i) => (
          <div key={i} style={{display:"flex",justifyContent: msg.role==="user" ? "flex-end" : "flex-start"}}>
            <div style={{
              maxWidth:"80%",padding:"10px 14px",borderRadius:msg.role==="user"?"16px 16px 4px 16px":"16px 16px 16px 4px",
              background: msg.role==="user" ? "#1C2B1E" : "white",
              color: msg.role==="user" ? "#C8962C" : "#1e293b",
              fontSize:"13px",lineHeight:"1.5",
              boxShadow:"0 1px 4px rgba(0,0,0,0.08)",
              whiteSpace:"pre-line"
            }}>{msg.text}</div>
          </div>
        ))}
        {typing && (
          <div style={{display:"flex",gap:"4px",padding:"12px 14px",background:"white",borderRadius:"16px 16px 16px 4px",width:"fit-content",boxShadow:"0 1px 4px rgba(0,0,0,0.08)"}}>
            {[0,1,2].map(i => <div key={i} style={{width:"6px",height:"6px",borderRadius:"50%",background:"#94a3b8",animation:"bounce 1s infinite",animationDelay:`${i*0.2}s`}} />)}
          </div>
        )}
      </div>

      {/* Canned queries */}
      <div>
        <div style={{fontSize:"11px",color:"#94a3b8",marginBottom:"8px",letterSpacing:"1px"}}>SUGGESTED QUERIES</div>
        <div style={{display:"flex",flexDirection:"column",gap:"6px"}}>
          {CANNED.map((c,i) => (
            <button key={i} onClick={() => sendCanned(c.q, c.fn)} style={{
              textAlign:"left",padding:"9px 14px",background:"white",border:"1px solid #e2e8f0",
              borderRadius:"8px",fontSize:"13px",color:"#374151",cursor:"pointer",transition:"all 0.15s"
            }}>💬 {c.q}</button>
          ))}
        </div>
      </div>

      {/* Free input */}
      <div style={{display:"flex",gap:"8px"}}>
        <input value={input} onChange={e => setInput(e.target.value)} onKeyDown={e => e.key==="Enter" && sendFree()}
          placeholder="Ask anything about your hills..."
          style={{flex:1,padding:"10px 14px",borderRadius:"8px",border:"1px solid #e2e8f0",fontSize:"13px"}} />
        <button onClick={sendFree} style={{padding:"10px 16px",background:"#1C2B1E",color:"#C8962C",border:"none",borderRadius:"8px",fontWeight:700,cursor:"pointer"}}>→</button>
      </div>

      <style>{`@keyframes bounce { 0%,60%,100%{transform:translateY(0)} 30%{transform:translateY(-4px)} }`}</style>
    </div>
  );
}

export default function App() {
  const [view, setView] = useState("Dashboard");
  const [mountains, setMountains] = useState(ALL_MOUNTAINS);

  const navCfg = {
    "Dashboard":  { icon:"📊", color:"#1C2B1E" },
    "Hill List":  { icon:"🗂️", color:"#1E4D8C" },
    "Log Ascent": { icon:"✍️", color:"#8B3A00" },
    "Copilot":    { icon:"🤖", color:"#14532D" },
  };

  return (
    <div style={{minHeight:"100vh",background:"#f1f5f2",fontFamily:"system-ui,-apple-system,sans-serif"}}>
      {/* Top bar */}
      <div style={{background:"#1C2B1E",padding:"12px 20px",display:"flex",alignItems:"center",justifyContent:"space-between"}}>
        <div style={{display:"flex",alignItems:"center",gap:"10px"}}>
          <span style={{fontSize:"20px"}}>⛰️</span>
          <div>
            <div style={{color:"white",fontWeight:700,fontSize:"15px"}}>Munroist</div>
            <div style={{color:"#8FA89B",fontSize:"11px"}}>Power Apps Canvas App · Dataverse</div>
          </div>
        </div>
        <div style={{background:"#C8962C",color:"#1C2B1E",padding:"4px 10px",borderRadius:"12px",fontSize:"11px",fontWeight:700}}>
          {mountains.filter(m=>m.done).length} ascents logged
        </div>
      </div>

      {/* Nav */}
      <div style={{background:"white",borderBottom:"1px solid #e2e8f0",display:"flex",overflowX:"auto"}}>
        {Object.entries(navCfg).map(([v,{icon,color}]) => (
          <button key={v} onClick={() => setView(v)} style={{
            padding:"12px 20px",border:"none",borderBottom: view===v ? `3px solid ${color}` : "3px solid transparent",
            background:"transparent",cursor:"pointer",fontSize:"13px",fontWeight:700,
            color: view===v ? color : "#94a3b8",display:"flex",alignItems:"center",gap:"6px",whiteSpace:"nowrap",transition:"all 0.15s"
          }}>{icon} {v}</button>
        ))}
      </div>

      {/* Content */}
      <div style={{maxWidth:"680px",margin:"0 auto",padding:"20px 16px"}}>
        {view === "Dashboard"  && <Dashboard mountains={mountains} setView={setView} />}
        {view === "Hill List"  && <HillList mountains={mountains} setMountains={setMountains} />}
        {view === "Log Ascent" && <LogAscent mountains={mountains} setMountains={setMountains} setView={setView} />}
        {view === "Copilot"    && <CopilotPanel mountains={mountains} />}
      </div>
    </div>
  );
}
